import { roundToTwoDecimal } from "../roundToTwoDecimal";

export const countPriceCoefficient = (price: number, removalPrice: number) =>
  price && removalPrice ? roundToTwoDecimal(price / removalPrice) : null;
